import { useDispatch } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './unassignedInquiryCard.module.scss';
import PropertyData from '../../PendingEvents/PropertyData';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function UnassignedInquiryCard({ inquiry, trackCallback = null }) {
  const dispatch = useDispatch();
  const { id, property, lead_name, hours_since_created, display_hours } =
    inquiry;
  const toolTipText = Trans(translations, 'ReceivedAgo');
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');

  const handleClickInquiry = () => {
    const url = `${tokkoBrokerHost}/marketing/webcontact/${id}/`;
    window.open(url, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  const handleQDOpen = (event) => {
    event.stopPropagation();

    if (property?.id) {
      dispatch(showQuickDisplay({ id: property?.id }));

      if (trackCallback) {
        trackCallback(TRACK_ELEMENT.PROPERTY_ADDRESS);
      }
    }
  };

  return (
    <Box onClick={handleClickInquiry} className={styles.unassignedInquiryCard}>
      <Box className={styles.propertyDataContainer}>
        {!property ? (
          <Text className={styles.noPropertyText}>
            {Trans(translations, 'NoAssociatedProperty')}
          </Text>
        ) : (
          <PropertyData
            picture={property.property_picture_url}
            address={property.address}
            location={property.location}
            id={property.id}
            onClick={handleQDOpen}
          />
        )}
      </Box>
      <Text className={styles.leadNameText}>{lead_name}</Text>
      <TimeStatusIndicator
        value={hours_since_created}
        displayTime={display_hours}
        threshold={1}
        alertOnExceed
        toolTipText={toolTipText}
      />
    </Box>
  );
}

export default UnassignedInquiryCard;
